import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./ActivityFeed.styled";
import { ActivityEvent } from "./ActivityEvent";
export const ActivityFeed = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { activities, indicatorType = "icon", titleHeadingLevel, children, ...otherProps } = props;
    return (_jsxs(Styled.ActivityFeed, { ref: ref, "data-testid": "ActivityFeed", ...otherProps, children: [activities &&
                activities.map((activity, index) => (_jsx(ActivityEvent, { titleHeadingLevel: titleHeadingLevel, ...activity, indicatorType: indicatorType }, index))), children] }));
});
ActivityFeed.displayName = "ActivityFeed";
ActivityFeed.defaultProps = {
    indicatorType: "icon"
};
